import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { COLORS, fontMixin, getColorByService } from "../../../../../../../../../styles";
import { ServiceName } from "../../../../../../../../../constants";

interface GLI_ContainerProps {
	$service: ServiceName;
}

export const GLI_Container = styled(motion.div)<GLI_ContainerProps>`
	width: 100%;
	height: 100%;
	position: relative;
	border: 0;
	border-radius: 10px 10px 0 0;
	background: #ffffff;
	box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
	padding: 10px 20px;
	text-align: left;
	overflow: hidden;
	${fontMixin({ size: 12 })};
	line-height: 17px;
	color: ${COLORS.Dark_Gray};
	cursor: pointer;
	display: flex;
	align-items: center;

	&:hover {
		background: ${COLORS.Light_Gray};
	}

	${({ $service }) => {
		const color = getColorByService($service);

		return css`
			${GLI_ProgressFill}, ${GLI_CountLesson} {
				background: ${color};
			}
		`;
	}}
`;

export const GLI_ProgressBar = styled(motion.div)`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 4px;
	border-radius: 2px 2px 0 0;
	background: ${COLORS.White};
	overflow: hidden;
	z-index: 100;
`;

export const GLI_ProgressFill = styled(motion.div)`
	position: relative;

	height: 100%;
	border-radius: inherit;
	overflow: hidden;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		width: 40%;
		left: -40%;
		background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
		animation: progressShine 1s ease 0.35s 1;
	}

	@keyframes progressShine {
		from {
			left: -40%;
		}
		to {
			left: 100%;
		}
	}
`;

export const GLI_Name = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	min-width: 0;
	word-break: break-word;
	padding-right: 15px;
`;

export const GLI_CountLesson = styled(motion.div)`
	position: absolute;
	right: 10px;
	bottom: 8px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${COLORS.White};
	${fontMixin({ size: 11 })}
`;

export const groupLessonItemVariants = {
	hidden: {
		opacity: 0,
		y: 8,
		scale: 0.96,
	},
	visible: {
		opacity: 1,
		y: 0,
		scale: 1,
		transition: {
			duration: 0.26,
			ease: [0.16, 1, 0.3, 1],
		},
	},
	exit: {
		opacity: 0,
		y: -6,
		scale: 0.96,
		transition: {
			duration: 0.16,
		},
	},
};
